import React from 'react';
import { Search, Eye, FileCheck, Repeat } from 'lucide-react';

const steps = [
  {
    n: '01',
    icon: Search,
    title: 'Audit im laufenden Betrieb',
    text: 'Unser Techniker scannt Ihre Anlage mit dem Ultraschall-Messgerät – ohne Stillstand, ohne Produktionsausfall, ohne Risiko.',
  },
  {
    n: '02',
    icon: Eye,
    title: 'Visuelle Ortung & Quantifizierung',
    text: 'Jedes Leck wird auf dem Display sichtbar gemacht und in Volumenstrom (m³/h) sowie € pro Jahr exakt beziffert.',
  },
  {
    n: '03',
    icon: FileCheck,
    title: 'ISO 50001 Bericht',
    text: 'Sie erhalten einen schlüsselfertigen, TÜV-tauglichen Energieeffizienz-Report – sofort einsetzbar fürs Audit.',
  },
  {
    n: '04',
    icon: Repeat,
    title: 'Monatliches Monitoring',
    text: 'Kontinuierliche Audits sichern Ihre Einsparung dauerhaft und verhindern neue, kostenintensive Lecks.',
  },
];

export default function Method() {
  return (
    <section id="methode" className="py-16 sm:py-24 md:py-32 relative" data-testid="method-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <div className="eyebrow mb-5">Methode</div>
          <h2 className="font-display font-black text-slate-900 text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-[1.02]">
            Vier Schritte vom Verlust zur<br />
            <span className="text-[#0891b2]">messbaren Einsparung.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.n} className="card-surface p-5 sm:p-7 relative" data-testid={`method-step-${s.n}`}>
                <div className="flex items-start justify-between mb-10">
                  <div className="w-11 h-11 grid place-items-center border border-[#0891b2]/30 bg-[#0891b2]/5">
                    <Icon className="w-5 h-5 text-[#0891b2]" strokeWidth={1.8} />
                  </div>
                  <div className="font-display font-black text-slate-200 text-4xl tracking-tighter">{s.n}</div>
                </div>
                <h3 className="font-display font-bold text-slate-900 text-lg mb-3 leading-tight tracking-tight">{s.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
